const duration = 2;
export const notiConfig = {
  addError: {
    message: "Empty action bae? ",
    description:
      "Seems like you have just enter an empty todo. Please check your todo input !",
    duration: duration,
  },
  addSuccess: {
    message: "Success !",
    description: "Add your new todo successfully ! Please check your todo list",
    duration: duration,
  },
  deleteSuccess: {
    message: "Success !",
    description: "Delete data successfully !",
    duration: duration,
  },
  updateSuccess: {
    message: "Success !",
    description: "Update data successfully !",
    duration: duration,
  },
  loadSuccess: {
    message: "Load data success !",
    description: "Loading data successfully !",
    duration: duration,
  },
};
